export default class SendManager {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      accountId: null,
      eventId: null,
      mailingId: null,
      finishedAt: '',
      isAborted: false,
      isRunning: false,
      isTransfered: false,
      mailingName: '',
      priority: null,
      receiverCount: null,
      sendAt: '',
      startedAt: null,
      transferRate: 0
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  /* Currently no saving planned
  getJSON() {
    return {
      id: this.id,
      accountId: this.accountId,
      eventId: this.eventId,
      mailingId: this.mailingId,
      finishedAt: this.finishedAt,
      isAborted: this.isAborted,
      isRunning: this.isRunning,
      isTransfered: this.isTransfered,
      mailingName: this.mailingName,
      priority: this.priority,
      receiverCount: this.receiverCount,
      sendAt: this.sendAt,
      startedAt: this.startedAt,
      transferRate: this.transferRate
    }
  }
  */
}



// WEBPACK FOOTER //
// ./src/components/sendManager/model.js